
<template>
  <div class="zj-moble-app-page">
   <div class="zj-mt-content">
      <div ref="map-mapview" class="zj-mt-mapview">
        <ZJMobileMapViewApp MapKey="MobileHotMap"></ZJMobileMapViewApp>
      </div>
      <!-- <div class="zj-mt-rescueteam">涉及救援队人员</div> -->
    </div>
   <!-- <div class="zj-mt-footer">
      <mt-button type="primary" @click.native="IsVisible = true" size="large">任务反馈</mt-button>
    </div> -->
  </div>
</template>

<script>
import Vue from "vue";
import { Field, Cell } from "mint-ui";

import ZJMobileMapViewApp from "./component/MapView.vue";


Vue.component(Field.name, Field);
Vue.component(Cell.name, Cell);


export default {
  name: "MobileHotMapView",
  componentName: "MobileHotMapView",
  components: {
    ZJMobileMapViewApp,
  },
  controller: "Home",
  action: "MobileHotMapView",
  data() {
    return {
      isVideoMonitorDialogVisible: false,
      streamType: 1, //0 - 主码流；1 - 子码流
      autoplay: false,
      cameraId: "",
      cameraName:""
    };
  },
  methods: {
    layerButtonClick: function(data) {
      let e = data.e;
      switch (data.action) {
        case "videomonitor":
          this.cameraId = e.data.DeviceId;
          this.cameraName = e.data.DeviceName;
          this.isVideoMonitorDialogVisible = true;
          break;
        default:
          this.$message({ type: "warning", message: data.action + "未实现" });
          break;
      }
    },
  },
};
</script>

<style scoped>
.zj-vehicleview-root {
  height: 100%;
  width: 100%;
}
</style>
